import { Outlet } from "react-router-dom";

import { FilterUtilServiceProvider } from "./filter-util-service/filter-util-service.context";
import './util-service.scss';

export function UtilService() {
  return (
    <div id="ShellUtilService" className="util-service">
       <FilterUtilServiceProvider>
        <Outlet />
      </FilterUtilServiceProvider>
    </div>
  );
}

export default UtilService;
